var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQueryClient, } from "@tanstack/react-query";
import { useAccountFeaturesQuery, useAccountSummaryV2Query as useAccountSummaryQuery, useCreditAccountsQuery, } from "syf-api";
import getApiConfig from "../helpers/getApiConfig";
import { useConfig } from "../hooks/useConfig";
export var useAccountSummary = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountSummaryQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
export var useAccountFeatures = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountFeaturesQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
export var useCreditAccounts = function (shouldCallCreditAccountsQuery) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getApiConfig(queryClient, mfeConfig, shouldCallCreditAccountsQuery);
    return useCreditAccountsQuery(__assign({ keyProps: undefined }, apiConfig));
};
//# sourceMappingURL=syfApiQueries.js.map